import React from 'react';
import aboutTeacherImg from "../assets/images/aout.png"

import "../styles/about.css"

function About(props) {
    return (
        <div id="about">
            <div id="aboutintro">
                <h1>
                    WHO ARE WE?
                
                </h1>
                <h3>
                    <b>Hassan Quran Academy</b> being an online Quran academy is playing its role as the best online Quran teaching institute. Having vast experience of teaching, Quran memorization (Hifz), Noorani Qaida, Basic Tajweed, course and Islamic studies for kids, adult and female. AlhamduliAllah.
                You are never too young neither too old to learn. Hassan Academy provides Quran, Islam, and Arabic lessons for both kids and adults. We cater to all age groups as we strongly believe the knowledge of the Quran to be highly significant and valuable to people of all ages.
                </h3>
            </div>
            {/* =========== */}
            <div id="aboutteacherContainer">
                {/* <div>
                    <img id="aboutTeacherimg" src={aboutTeacherImg} />
                </div> */}
                <div id="aboutTeachercontent">
                    <h1>
                    ABOUT OUR TEACHERS
                    </h1>
                    <p>
                    Teaching Quran is a task of big responsibility so in order to fulfill this responsibility we hire the best tutors for our students.  Their selection is made on the basis of their religious morals and educational background. Forgiving Online Quran Classes to our students, we hire full-time tutors and the recruitment process is based on their Quran recitation, Tajweed and communication skills. They can deliver a lecture in a very professional manner and are also capable of speaking both English and Arabic. The tutors are well qualified because we give them special training so that they become able to deliver what we have promised to our students. Every student is given individual attention by an online Quran teacher. The teachers are not only arranged for adult students, but they also give online Quran classes for kids. The main features of the tutors include                        <br />
                        Highly Qualified and Experienced in Quranic and Islamic Teachings.
                        <br />
                        Highly Qualified and Experienced in Quranic and Islamic Teachings.
                        <br />
                        Fully Trained in the Arabic language
                        <br />
                        Huffaz-e-Quran tutors for the memorization class
                        <br/>
                        Completely aware of Recitation rules.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default About;